import React,{Fragment} from 'react';
import PageWrapper from "../../components/PageWrapper";
import ToolBarMenu from './../../components/ToolBarMenu/index';
import Header from './../../components/Header/index';
import PageHeader from './../../components/PageHeader/index';
import Footer from './../../components/Footer/index';
import AnnouncementDetail from './AnnouncementDetail';
import { useAnnouncementDetail } from './../../queries/announcementDetail';
import { useAnnouncement } from '../../queries/announcement';
import InfinitProgressBar from '../../components/InfiniteProgressBar';


const Announcement = () => {

    const AnnouncementId = window.location.pathname.split("/").pop();
    const AnnouncementInfo = useAnnouncementDetail(AnnouncementId);
    const AnnouncementData = useAnnouncement();
    if (AnnouncementData.error) return <div>error!</div>
    if (AnnouncementData.loading) return <InfinitProgressBar />
    
    if (AnnouncementInfo.error) return <div>error!</div>
    if (AnnouncementInfo.loading) return <InfinitProgressBar />

    return (
        <Fragment>
            {/* <ToolBarMenu/> */}
            <Header/>
            <PageHeader
                bgImg={AnnouncementData.data.announcementTopHeader[0].announcementPageHeaderImage.urls[0]}
                title={AnnouncementData.data.announcement.displayText}
                content=' '
            />

            <PageWrapper classes={'product-details-wrapper sm-top'}>
                <div className="col-12">
                    <AnnouncementDetail res={AnnouncementInfo.data}/>
                </div>
            </PageWrapper>
            <br/>
            <br/>
            <br/>
            <Footer/>
        </Fragment>
    );
};

export default Announcement;